import { INPUT_TYPES } from '../utils/constants.js';
export default {
    title: 'Video Sound Volume',
    isRelevant: () => true,
    isRelevantDescription: 'Always relevant.',
    type: INPUT_TYPES.NUMBER,
    min: 0,
    max: 1,
    step: 0.01,
    default: 0,
    description: `Videos are muted by default in the gallery, assign a decimal value 0-1 to set the initial volume`,
};
//# sourceMappingURL=behaviourParams_item_video_volume.js.map